module.exports = __webpack_public_path__ + "static/media/homePageIpad.9cf50813.mp4";